import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";

const Highlights = ({project}) => {

  const keyHighlights = project?.keyHighlights || []; // Use project keyHighlights or default empty array

  if (keyHighlights.length === 0) return null; // Hide section if no highlights exist

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Highlights</h2>
      <ul className="space-y-2">
        {keyHighlights.map((highlight, index) => (
          <li key={index} className="flex items-center bg-white text-gray-700">
            <AiOutlineCheckCircle className="text-green-500 text-lg mr-2" />
            {highlight}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Highlights;
